export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_12.0960bdd1.jpg";